export const simpleClone = <T>(object: unknown) => JSON.parse(JSON.stringify(object)) as T;

// Use to filter array of objects on a specific key. Example: [{id: '123'}, {id: 456}, {id: 123}].filter(filterOnDuplicateObjectKey('id')) => [{id: '123'}, {id: 456}]
export const filterOnDuplicateObjectKey =
    <T>(key: keyof T) =>
    (item: T, index: number, self: T[]) =>
        self.findIndex((i) => i[key] === item[key]) === index;

// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unused-vars
export const removeEmptyProperties = <T extends Record<string, any>>(obj: T): Partial<T> =>
    Object.fromEntries(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        Object.entries(obj).filter(([_key, value]) => {
            if (value != null && (Array.isArray(value) || typeof value === 'object')) {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                return Object.keys(value).length !== 0;
            }
            return value != null;
        })
    ) as Partial<T>;
